<template>
  <v-avatar class="asc-avatar" :size="32" :color="getBackgroundColor">
    <template v-if="!hasImage">
      <asc-label
        size="sm"
        :value="getInitials"
        :color="getFontColor"
      ></asc-label>
    </template>
    <template v-if="hasImage">
      <img :src="image.src" :alt="image.alt" />
    </template>
  </v-avatar>
</template>

<script>
import AscLabel from './AscLabel'
import variables from '@/styles/_varsJs.scss'
import { profileNameInitials } from '@/utilities/profile'

export default {
  name: 'AscAvatar',

  components: {
    AscLabel,
  },

  props: {
    fullName: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '',
    },
    isInternal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasImage() {
      return this.image && this.image.src && this.image.alt
    },
    hasFullName() {
      return this.fullName && this.fullName !== ''
    },
    getInitials() {
      const fullName = this.fullName
      return profileNameInitials(fullName)
    },
    getBackgroundColor() {
      if (!this.hasFullName) {
        return variables.gray200
      }
      return this.isInternal ? variables.gray800 : variables.gray200
    },
    getFontColor() {
      return this.isInternal ? variables.primarywhite : variables.primaryblack
    },
  },
}
</script>
